const ASSIGNED_CAN_VIEW_FILTER_ID = "assignedcanviewfilter"

const getAssignedCanViewFilter = (user, boardUser, canViewField, assignedBoardUsersField) => {
  return {
    id: ASSIGNED_CAN_VIEW_FILTER_ID,
    hidden: true,
    filterBy: (record) => record.isPhantom || (user.can(record[canViewField]) || record[assignedBoardUsersField].includes(boardUser.id))
  }
}

export const SwivuStoreAssignedCanViewMixin = (Target, boardUsersStore, canViewField = "canView", assignedBoardUsersField = "assignedBoardUsers") => class extends Target {
  static get $name() {
    return "SwivuAssignedCanViewMixin"
  }

  static get configurable() {
    return {
      reapplyFilterOnUpdate: true
    }
  }

  applyState(state) {
    super.applyState(state);
    this.swivuAssignedViewStateChange();
  }

  swivuAssignedViewStateChange() {
    if (!this.currentBoardUser) {
      this.currentBoardUser = boardUsersStore.find((boardUser) => boardUser.userId === boardUsersStore.swivuCurrentUser.id)
    }
    // There is an issue this.currentBoardUser can be null where the boardUserStore is not loaded to project till this
    // time of calling and we are utilizing the store
    if (this.currentBoardUser && !this.filters.find(filter => filter.id === ASSIGNED_CAN_VIEW_FILTER_ID)) {
      this.filters = [
        ...this.filters,
        getAssignedCanViewFilter(boardUsersStore.swivuCurrentUser, this.currentBoardUser, canViewField, assignedBoardUsersField)
      ]
      this.filter();
    }
  }

  /* This function is called from projectConfig.jsx line: 774, it starts the process of applying the filters of this mixin */
  swivuPerformMixinActions() {
    this.swivuAssignedViewStateChange();
  }
}
